module.exports = __webpack_public_path__ + "static/img/fix3.ee41f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fix3.jpg
// module id = bLx5
// module chunks = 1